import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsTextWithIconBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsTextWithIconBlockEntity
